import { useFormik } from 'formik'
import { useState } from 'react'
import { options } from './types'
import fetchToCurl from 'fetch-to-curl'
import { header } from '../../constants'
import { useHandleResponseError } from '../../utils'

export const useOpenKaito = () => {
    const { handleResponseError } = useHandleResponseError()

    const [isLoading, setIsLoading] = useState(false)
    const [results, setResults] = useState<any>(null)
    const [cUrl, setCurl] = useState<string>('')

    const initialValues = {
        synapse_type: options[0].value,
        query_string: 'TAO OR Bittensor',
        size: 5,
        later_than_timestamp: 1693894207,
        index_name: 'eth_denver',
        timeout: 10,
        axon_uid: null,
    }

    const handleSubmit = async (values: any) => {
        setResults(null)

        try {
            const {
                synapse_type,
                timeout = 10,
                query_string,
                size,
                index_name = 'eth_denver',
                later_than_timestamp = 1693894207,
                axon_uid,
            } = values

            const query = `${
                import.meta.env.REACT_APP_SUBNET_API
            }/s5_epsilon?synapse_type=${synapse_type}&timeout=${timeout}${
                axon_uid ? `&axon_uid=${axon_uid}` : ''
            }`

            const options = {
                method: 'POST',
                headers: header,
                body: JSON.stringify({
                    SearchSynapse: {
                        query_string: query_string,
                        size: size,
                    },
                    StructuredSearchSynapse: {
                        query_string: query_string,
                        size: size,
                        later_than_timestamp: later_than_timestamp,
                    },
                    SemanticSearchSynapse: {
                        query_string: query_string,
                        size: size,
                        index_name: index_name,
                    },
                }),
            }

            const curlString = fetchToCurl(query, options)?.replace(/\$/g, '\\$')

            const res: any = await fetch(query, options)

            handleResponseError(res)

            setCurl(curlString)

            const data = await res.json()

            setResults(data?.response?.[0]?.results)
        } catch (e) {
            console.log(e)
        }
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: async (values, formikHelpers) => {
            formikHelpers.setFieldValue('query_string', '') // Reset message to empty string immediately
            setIsLoading(true)
            await handleSubmit(values)
            setIsLoading(false)
        },
    })

    return {
        isLoading,
        formik,
        results,
        cUrl,
    }
}
